import './App.css';
import Home from './Components/Home';
import Event from './Components/Event';
import PhotoGallery from './Components/PhotoGallery';
import Registry from './Components/Registry';
import Youtubelive from './Components/Youtubelive';
import MyBooking from './Components/MyBooking';
import Navbar  from './Shared/Navbar';
import Footer from './Shared/Footer';
import RegConfirm from './Components/RegConfirm';
import RegComplete from './Components/RegComplete';
import Booking from './Components/Booking';
import Sponsor from './Components/Sponsor';
import DealerCourse from './Components/DealerCourse';
import SkillCourse from './Components/SkillCourse';

//import { BrowserRouter as Router,Route,Routes } from 'react-router-dom';
import { HashRouter as Router,Route,Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";


function App() {
  return (
    <div>
      <Router>
        <Navbar/>
        <Routes>
          <Route path="/" element = {<Home/>}/>
          <Route path="/home" element ={<Home/>}/>
          <Route path="/event" element={<Event/>}/>
          <Route path="/booking" element={<Booking/>}/>
          <Route path="/myBooking" element ={<MyBooking/>}/>
          <Route path="/photoGallery" element={<PhotoGallery/>}/>
          <Route path="/youtubeLive" element={<Youtubelive/>}/>
          <Route path="/registry" element={<Registry/>}/>
          <Route path="/regConfirm" element ={<RegConfirm/>}/>
          <Route path="/regComplete" element={<RegComplete/>}/>
          <Route path="/sponsor" element ={<Sponsor/>}/>
          <Route path="/dealerCourse" element={<DealerCourse/>}/>
          <Route path="/skillCourse" element ={<SkillCourse/>}/>

          
        </Routes>
        <Footer/>

        <ToastContainer>
          bodyClassName="toastBody"
        </ToastContainer>
      
     </Router>
    </div>
  );
}

export default App;
